import {
  ButtonIcon,
  ButtonText,
  OutlinedButton,
} from '@prisjakt/ui/button/variants';
import { IconClose } from '@prisjakt/ui/icon';
import React from 'react';

export const ActiveFilterIndicator: React.VFC<ActiveFilterIndicatorProps> = props => {
  return (
    <OutlinedButton onClick={props.onClickHandler}>
      <ButtonText>{props.text}</ButtonText>
      <ButtonIcon>
        <IconClose />
      </ButtonIcon>
    </OutlinedButton>
  );
};

interface ActiveFilterIndicatorProps {
  text: string;
  onClickHandler: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}
